/** Flat Discord-style chrome — pre–premium redesign palette. */
export const CLASSIC_APP_THEME = {
    id: 'classic',
    name: 'Classic',
    description: 'Neutral dark surfaces and indigo accents without glass panels.',
    typography: {
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            'Helvetica',
            'Arial',
            'sans-serif',
        ],
    },
    layout: {
        appShellPadding: '0',
        appShellGap: '0',
        panelBorderRadius: '0',
        channelSidebarWidth: '20rem',
        channelHeaderHeight: '4.5rem',
        composerBorderRadius: '0.5rem',
    },
    colors: {
        base: {
            deepest: '#111113',
            deep: '#18181b',
            DEFAULT: '#18181b',
        },
        brand: {
            50: '#eef2ff',
            100: '#e0e7ff',
            200: '#c7d2fe',
            300: '#a5b4fc',
            400: '#818cf8',
            500: '#6366f1',
            600: '#4f46e5',
            700: '#4338ca',
            800: '#3730a3',
            900: '#312e81',
        },
        accent: {
            violet: '#6366f1',
            purple: '#818cf8',
            blue: '#3b82f6',
            cyan: '#06b6d4',
        },
        surface: {
            900: '#111113',
            800: '#18181b',
            700: '#1f1f23',
            600: '#27272a',
            500: '#3f3f46',
            400: '#52525b',
        },
    },
    borders: {
        subtle: 'rgba(255, 255, 255, 0.06)',
        medium: 'rgba(63, 63, 70, 1)',
        strong: 'rgba(82, 82, 91, 1)',
    },
    shadows: {
        panel: 'none',
        glowViolet: 'none',
        glowBlue: 'none',
        appShell: 'none',
        channelRowActive: 'none',
        composerFocus: 'none',
        depthPanel: '0 4px 20px rgba(0,0,0,0.4), 0 12px 40px rgba(0,0,0,0.25)',
        depthButton: '0 2px 8px rgba(0,0,0,0.32)',
        depthControl: '0 2px 8px rgba(0,0,0,0.28)',
    },
    effects: {
        ambientOrbBlur: '0',
        ambientOrbOpacity: 0,
        ambient: {
            violet: '#6366f1',
            purple: '#818cf8',
            blue: '#3b82f6',
            cyan: '#06b6d4',
        },
        scrollbarThumb: 'rgb(82, 82, 91)',
        scrollbarThumbHover: 'rgb(113, 113, 122)',
        premiumTransitionMs: 100,
    },
    gradients: {
        serverBannerOverlay: 'linear-gradient(180deg, rgba(17, 17, 19, 0.2) 0%, rgba(24, 24, 27, 0.85) 100%)',
        serverBannerGlow: 'none',
        composerGlow: 'none',
    },
    chrome: {
        enableAmbientLights: false,
        enableAppShellBorder: false,
        enableComposerGlow: false,
        enableDepthShadows: false,
        panelSidebarBg: '#18181b',
        panelChatBg: '#111113',
        panelMembersBg: '#18181b',
        panelBackdropBlur: '0',
    },
};
//# sourceMappingURL=classic.theme.js.map